import axios from "axios";
import jwtDefaultConfig from "../../src/@core/auth/jwt/jwtDefaultConfig";

// Production toggle — when true, do NOT send API requests and hide console output.
const isProduction = process.env.REACT_APP_IS_PRODUCTION === "true" || process.env.NODE_ENV === "production";

const NETWORK_DISABLED = isProduction;
const DEFAULT_API_URL = "https://preprod-pms-dec-api.potenzer.com/api";
const RESOLVED_API_URL =
  process.env.REACT_APP_API_URL || process.env.REACT_APP_BASE_URL || DEFAULT_API_URL;
const BASE_URL = RESOLVED_API_URL.replace(/\/+$/, "");
const API_ORIGIN = BASE_URL.replace(/\/api$/i, "");
export const Image_base_uri = process.env.REACT_APP_IMAGE_URI || API_ORIGIN;
export const Staah = process.env.REACT_APP_STAAH || BASE_URL;

const jwtconfig = { ...jwtDefaultConfig };

// console disable in production
if (isProduction && typeof console !== "undefined") {
  const noop = () => {};
  ["log", "info", "warn", "error", "debug", "trace", "group", "groupEnd", "table", "dir"].forEach((m) => {
    try {
      if (console[m]) console[m] = noop;
    } catch (e) {
      // ignore
    }
  });
}

// Base URLs — avoid embedding real production hosts in sample code.

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

// Block outgoing requests when NETWORK_DISABLED is true.
// axiosInstance.interceptors.request.use(
//   function (config) {
//     if (NETWORK_DISABLED) {
//       return Promise.reject({
//         message: "Network disabled by build configuration",
//         __networkDisabled: true,
//         config,
//       });
//     }
//     return config;
//   },
//   function (error) {
//     return Promise.reject(error);
//   },
// );

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    try {
      // allow request to opt out from triggering global auth-invalid handling
      const reqConfig = error?.config || {};
      const skip = reqConfig.skipAuthInvalid === true;
      const url = (reqConfig.url || "").toString().toLowerCase();
      // endpoints that should not trigger auth-invalid (password flows etc.)
      const ignorePaths = [
        "/auth/forgotpassword",
        "/auth/resetpassword",
        "/auth/changepassword",
        "/bookingengine/getbookingbyid",
      ];
      if (skip || ignorePaths.some((p) => url.includes(p))) {
        return Promise.reject(error);
      }

      const status = error?.response?.status;
      const data = error?.response?.data || {};
      const msg = (
        data.Message ||
        data.message ||
        (typeof data === "string" ? data : "")
      ).toString();
      if (status === 401) {
        if (typeof window !== "undefined" && window.dispatchEvent) {
          window.dispatchEvent(
            new CustomEvent("auth-invalid", {
              detail: { message: "Session expired. Please login again." },
            }),
          );
        }
        return Promise.reject(error);
      }
    } catch (e) {
      // ignore
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
